import { apiClient } from './api-client';
import { AddressSuggestion, BuildingData } from '@/types/index';

export const addressService = {
  /**
   * Search addresses with autocomplete
   * Returns suggestions from Open Swiss Buildings API
   */
  async searchAddresses(query: string): Promise<AddressSuggestion[]> {
    if (!query || query.length < 3) {
      return [];
    }
    return apiClient.get<AddressSuggestion[]>('/addresses/search', {
      params: { q: query },
    });
  },

  /**
   * Get building data by EGID from local RegBL database
   * Returns building details: year, heating type, floors, condition
   */
  async getBuildingData(egid: number): Promise<BuildingData> {
    return apiClient.get<BuildingData>(`/addresses/building-data/${egid}`);
  },
};
